export function isWebToCaseMaintenancePath(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/maintenance';
}
